import React, { useContext } from 'react';
import { WarehouseIndexContext, useActionsWarehouseIndex, useDispatchWarehouseIndex, useWarehouse } from '../../../../context/inventory/WarehouseIndexProvider';
import '../../../../app.css';
import './CreateWarehouse.css';

import {
  faFloppyDisk,
  faSquarePlus,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { types } from '../../../../reducers/inventory/warehouseReducer';


export const CreateWarehouse = () => {

  const state = useWarehouse();
  const dispatch = useDispatchWarehouseIndex();
  const action =useActionsWarehouseIndex();


  const {
    edit_warehouse: {
      name,
      id,
      code,
    },
    for_edit: for_edit,
  } = state;

  return (
    <div>
      <div className="row">

        <div className="mb-3 input-code">
          <label className="form-label">Código de almacén</label>
          <input value={code} type="number" className="form-control" id="exampleInputText" onChange={(e) => action.setFieldFormWarehouse(e.target.value, "code")} />
        </div>

        <div className="mb-3 col-md-3">
          <label className="form-label">Nombre de almacén</label>
          <input value={name} type="text" className="form-control" id="exampleInputText" onChange={(e) => action.setFieldFormWarehouse(e.target.value, "name")} />
        </div>

        <div className="div-for-btn-warehouse">
          <div
            onClick={() => {
              for_edit ? action.editWarehouseClick() : action.createWarehouseClick()
            }}
            className="flex btn-default button-form-warehouse"
          >
            <FontAwesomeIcon
              className="margin-auto"
              icon={for_edit ? faFloppyDisk : faSquarePlus}
            />
            &nbsp;
            <span> {for_edit ? "Guardar" : "Crear"} </span>
          </div>
        </div>


      </div>
    </div>
  )
}
